import React from "react";

function Card({ className = "", ...props }) {
  return (
    <div
      data-slot="card"
      className={`card border rounded-3 shadow-sm d-flex flex-column gap-2 ${className}`}
      {...props}
    />
  );
}

function CardHeader({ className = "", ...props }) {
  return (
    <div
      data-slot="card-header"
      className={`card-header bg-white border-bottom d-grid gap-2 pt-4 px-4 ${className}`}
      style={{
        gridTemplateRows: "auto auto",
        alignItems: "start",
      }}
      {...props}
    />
  );
}

function CardTitle({ className = "", ...props }) {
  return (
    <h4
      data-slot="card-title"
      className={`m-0 lh-1 ${className}`}
      {...props}
    />
  );
}

function CardDescription({ className = "", ...props }) {
  return (
    <p
      data-slot="card-description"
      className={`text-muted mb-0 ${className}`}
      {...props}
    />
  );
}

function CardAction({ className = "", ...props }) {
  return (
    <div
      data-slot="card-action"
      className={`ms-auto ${className}`}
      style={{
        gridColumnStart: 2,
        gridRowStart: 1,
        gridRowEnd: 3,
        alignSelf: "start",
        justifySelf: "end",
      }}
      {...props}
    />
  );
}

function CardContent({ className = "", ...props }) {
  return (
    <div
      data-slot="card-content"
      className={`card-body px-4 ${className}`}
      {...props}
    />
  );
}

function CardFooter({ className = "", ...props }) {
  return (
    <div
      data-slot="card-footer"
      className={`card-footer d-flex align-items-center px-4 py-3 border-top ${className}`}
      {...props}
    />
  );
}

export {
  Card,
  CardHeader,
  CardFooter,
  CardTitle,
  CardAction,
  CardDescription,
  CardContent,
};
